import type { HTMLAttributes } from "react"

type SanityFile = HTMLAttributes<HTMLAnchorElement> & {
  asset: {
    url: string
    extension: string
    originalFilename: string // Name of the file which was uploaded. Url itself may be a hash or not.
    size: number
    updatedAt: string
  }
}

const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
const kbInBytes = 1024

// @url https://stackoverflow.com/a/18650828
function formatBytes(bytes: number) {
  if (!bytes) {
    return "0 Bytes"
  }

  const i = Math.floor(Math.log(bytes) / Math.log(kbInBytes))
  return `${parseFloat((bytes / kbInBytes ** i).toFixed(0))} ${sizes[i]}`
}

export const SanityFileLink = ({
  asset: { url, originalFilename, size, extension },
  ...linkProps
}: SanityFile) => {
  const title = `${originalFilename
    .replace(`.${extension}`, "")
    .replace(/_|-/g, " ")} (${extension.toUpperCase()}, ${formatBytes(size)})`

  return <a href={url} title={title} aria-label={title} target="_self" {...linkProps} />
}
